export const downloadIPhoneAppUrl = 'https://itunes.apple.com/app/approvalmax/id1439596637';
export const downloadAndroidAppUrl = 'https://play.google.com/store/apps/details?id=com.approvalmax';
